import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a2b06f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rk_add_prestas" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Vos événements", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Ajouter un événement", -1))
const _hoisted_4 = { class: "double" }
const _hoisted_5 = { class: "double" }
const _hoisted_6 = { class: "form_container" }
const _hoisted_7 = { class: "form_container" }
const _hoisted_8 = { class: "quadra" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Éditer un événement", -1))
const _hoisted_10 = { class: "double" }
const _hoisted_11 = { class: "double" }
const _hoisted_12 = { class: "form_container" }
const _hoisted_13 = { class: "form_container" }
const _hoisted_14 = { class: "quadra" }
const _hoisted_15 = { class: "data-cards" }
const _hoisted_16 = { class: "card-icon" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Ajouter un événement")
], -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "card-logo" }
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = { class: "info" }

import { onBeforeMount, onMounted } from 'vue'
import { ref } from "vue";
import axios from "axios";
import { toast } from 'vue3-toastify';
// import { useAdminStore } from '../../store/piniaAdmin'
import { useLoginStore } from '../../store/piniaLogin'
import PlusCircleOutlineIcon from 'vue-material-design-icons/PlusCircleOutline.vue';
import { LMap, LTileLayer, LMarker } from "@vue-leaflet/vue-leaflet";
// const store = useAdminStore()



export default /*#__PURE__*/_defineComponent({
  __name: 'addEventView',
  setup(__props) {

const storeLogin = useLoginStore()


// variable
const events = ref([]);
const currentEvent = ref(null);
const token = ref(storeLogin.currentToken);
const editOpened = ref(false);
const is_map_active = ref(false);
const prestaFormVisible = ref(false);
const urlServer = ref(process.env.VUE_APP_SERVER_URL);
const userData = ref(JSON.parse(storeLogin.currentUser));
const contact = ref({ lat: userData.value.location.coordinates[1], long: userData.value.location.coordinates[0] });



function activeForm() {
    prestaFormVisible.value = true;

}

function newEvent(event) {
    is_map_active.value = false;
    editOpened.value = false;

    setTimeout(() => {
        currentEvent.value = event;
        is_map_active.value = true;
        editOpened.value = true;
        currentEvent.value.dateDebut = currentEvent.value.dateDebut.replace(/:00.000Z/, "");
        currentEvent.value.dateFin = currentEvent.value.dateFin.replace(/:00.000Z/, "");
    }, 400);


}

function deleteEvent(event, index) {
    const response = confirm("Voulez vous supprimer l'événement : " + event.nomEvent);
    if (response) {
        axios.delete(process.env.VUE_APP_SERVER_URL + '/event/' + event._id, {
            headers: {
                'Authorization': `Basic ${token.value}`
            }
        })
            .then(function (response) {

                if (response.data == 'Event supprimé') {
                    events.value.splice(index, 1);
                }

            })
            .catch(function (error) {
                toast.error(error);
            });
    }
}
function checkAdress() {

    is_map_active.value = false;
    axios.get(`https://dev.virtualearth.net/REST/v1/Locations/FR/${contact.value.codePostale}/${contact.value.ville}/${contact.value.adresse}?key=AoDJrgfVItWTs_icYLtdaizY88Uv3yj-98Tr03Cr6TR1VONQwP3tPZw0EY-JWTaL`)
        .then(function (response) {
            // handle success

            contact.value.lat = response.data.resourceSets[0].resources[0].point.coordinates[0];
            contact.value.long = response.data.resourceSets[0].resources[0].point.coordinates[1];
            is_map_active.value = true;

        })
        .catch(function (error) {
            is_map_active.value = true;

            // handle error
            console.log(error);
        })

}

async function editEvent(values) {
    const form = new FormData();

    currentEvent.value.location.ville = values.form_presta.stepFour.ville;

    values.form_presta.stepThree.images.forEach((fileItem) => {
        form.append('images', fileItem.file)
    })


    currentEvent.value.location.coordinates = [contact.value.long, contact.value.lat];

    form.append('datas', JSON.stringify(currentEvent.value));

    axios.patch(process.env.VUE_APP_SERVER_URL + '/event/' + currentEvent.value._id, form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(function (response) {
            console.log(response);

            toast.success("Votre événement à été mis à jour!");

        })
        .catch(function (error) {
            toast.error(error);
        });


}


async function addEvent(values) {
    const form = new FormData();



    values.form_presta.stepThree.images.forEach((fileItem) => {
        form.append('images', fileItem.file)
    })

    const result = {};
    result.createur = userData.value._id;
    result.nomEvent = values.form_presta.stepOne.nomEvent;
    result.dateDebut = values.form_presta.stepTwo.dateDebut;
    result.dateFin = values.form_presta.stepTwo.dateFin;
    result.description = values.form_presta.stepThree.description;
    result.ville = values.form_presta.stepFour.ville;
    result.contactMail = contact.value.contactMail;
    result.contactPhone = contact.value.contactPhone;
    result.website = contact.value.website;
    result.nombreDePlaces = values.form_presta.stepTwo.nombreDePlaces;
    result.location = {
        type: "Point",
        coordinates: [
            contact.value.long,
            contact.value.lat
        ]
    };

    form.append('datas', JSON.stringify(result));

    axios.post(process.env.VUE_APP_SERVER_URL + '/event', form, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
        .then(function (response) {
            console.log(response);

            toast.success("Votre événement viens d'étre créée!");

        })
        .catch(function (error) {
            toast.error(error);
        });


}




onMounted(async () => {

    is_map_active.value = true;
})

onBeforeMount(async () => {
    // axios.get(process.env.VUE_APP_SERVER_URL + '/categories')
    //     .then(function (response) {
    //         // handle success
    //         categories.value = response.data;
    //         console.log(categories.value);
    //     })
    //     .catch(function (error) {
    //         // handle error
    //         toast.error(error);
    //     })




    axios.get(process.env.VUE_APP_SERVER_URL + '/events', {
        params: {
            userId: userData.value._id
        }
    })
        .then(function (response) {
            console.log(response.data);

            // handle success
            events.value = response.data;


        })
        .catch(function (error) {
            // handle error
            toast.error(error);
        })

})

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["add_event_form", { active: prestaFormVisible.value }])
    }, [
      _createVNode(_component_FormKit, {
        type: "form",
        "submit-label": "Ajouter un événement",
        onSubmit: addEvent
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createVNode(_component_FormKit, {
            type: "multi-step",
            "valid-step-icon": "check",
            name: "form_presta",
            "tab-style": "progress",
            "allow-incomplete": false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FormKit, {
                type: "step",
                name: "stepOne",
                label: "Informations"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    name: "nomEvent",
                    "floating-label": true,
                    label: "Nom de l'événement"
                  }),
                  _createVNode(_component_FormKit, {
                    type: "group",
                    modelValue: contact.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((contact).value = $event))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_FormKit, {
                          type: "email",
                          "floating-label": true,
                          label: "Adresse email de contact",
                          name: "contactMail",
                          validation: "required|email",
                          "validation-visibility": "live"
                        }),
                        _createVNode(_component_FormKit, {
                          type: "tel",
                          "floating-label": true,
                          name: "contactPhone",
                          label: "Numéro de téléphone",
                          placeholder: "0xxxxxxxxx",
                          validation: "matches:/^[0-9]{10}$/",
                          "validation-messages": {
                                        matches: 'Numéro non valide',
                                    },
                          "validation-visibility": "dirty"
                        }),
                        _createVNode(_component_FormKit, {
                          type: "url",
                          label: "Site internet",
                          "floating-label": true,
                          name: "website",
                          placeholder: "https://www.example.com...",
                          validation: "url"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_FormKit, {
                type: "step",
                name: "stepTwo",
                label: "Fiche entreprise"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_FormKit, {
                      type: "datetime-local",
                      name: "dateDebut",
                      label: "Date de début",
                      help: "Quand commence l'événement",
                      validation: "required|date_after",
                      "validation-visibility": "live"
                    }),
                    _createVNode(_component_FormKit, {
                      type: "datetime-local",
                      name: "dateFin",
                      label: "Date de Fin",
                      help: "Quand ce termine l'événement",
                      validation: "required|date_after",
                      "validation-visibility": "live"
                    }),
                    _createVNode(_component_FormKit, {
                      type: "number",
                      label: "Nombres de places",
                      name: "nombreDePlaces",
                      value: "0",
                      step: "1"
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_FormKit, {
                type: "step",
                name: "stepThree",
                label: "Présentation de l'événement"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_FormKit, {
                      name: "images",
                      type: "file",
                      label: "Images de l'événement",
                      help: "Nous vous conseillons d'en mettre 1 minimum",
                      multiple: "true",
                      accept: "image/*"
                    }),
                    _createVNode(_component_FormKit, {
                      name: "description",
                      type: "textarea",
                      label: "Présentation de l'événement",
                      rows: "10"
                    })
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_FormKit, {
                type: "step",
                name: "stepFour",
                modelValue: contact.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((contact).value = $event)),
                label: "Emplacement"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_FormKit, {
                        name: "adresse",
                        "floating-label": true,
                        label: "Emplacement de l'événement"
                      }),
                      _createVNode(_component_FormKit, {
                        name: "codePostale",
                        "floating-label": true,
                        label: "Code postale"
                      }),
                      _createVNode(_component_FormKit, {
                        name: "ville",
                        "floating-label": true,
                        label: "Ville"
                      }),
                      _createVNode(_component_FormKit, {
                        type: "button",
                        onClick: checkAdress
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Verifier l'adresse ")
                        ]),
                        _: 1
                      })
                    ]),
                    (is_map_active.value)
                      ? (_openBlock(), _createBlock(_unref(LMap), {
                          key: 0,
                          ref: "map",
                          zoom: 11,
                          center: [contact.value.lat, contact.value.long]
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(LTileLayer), {
                              url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                              "layer-type": "base",
                              name: "OpenStreetMap"
                            }),
                            _createVNode(_unref(LMarker), {
                              "lat-lng": [contact.value.lat, contact.value.long]
                            }, null, 8, ["lat-lng"])
                          ]),
                          _: 1
                        }, 8, ["center"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 2),
    (currentEvent.value !== null)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["edit_event_form", { active: editOpened.value }])
        }, [
          _createElementVNode("div", {
            class: "rk_closeEvent",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (editOpened.value = false))
          }),
          _createVNode(_component_FormKit, {
            type: "form",
            "submit-label": "Editer l'événement",
            onSubmit: editEvent
          }, {
            default: _withCtx(() => [
              _hoisted_9,
              _createVNode(_component_FormKit, {
                type: "multi-step",
                "valid-step-icon": "check",
                name: "form_presta",
                "tab-style": "progress",
                "allow-incomplete": false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FormKit, {
                    type: "step",
                    name: "stepOne",
                    label: "Informations"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_FormKit, {
                        name: "nomEvent",
                        modelValue: currentEvent.value.nomEvent,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentEvent.value.nomEvent) = $event)),
                        "floating-label": true,
                        label: "Nom de l'événement"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_FormKit, { type: "group" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_FormKit, {
                              type: "email",
                              "floating-label": true,
                              label: "Adresse email de contact",
                              name: "contactMail",
                              modelValue: currentEvent.value.contactMail,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentEvent.value.contactMail) = $event)),
                              validation: "required|email",
                              "validation-visibility": "live"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_FormKit, {
                              type: "tel",
                              "floating-label": true,
                              modelValue: currentEvent.value.contactPhone,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((currentEvent.value.contactPhone) = $event)),
                              name: "contactPhone",
                              label: "Numéro de téléphone",
                              placeholder: "0xxxxxxxxx",
                              validation: "matches:/^[0-9]{10}$/",
                              "validation-messages": {
                                        matches: 'Numéro non valide',
                                    },
                              "validation-visibility": "dirty"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_FormKit, {
                              type: "url",
                              label: "Site internet",
                              "floating-label": true,
                              modelValue: currentEvent.value.website,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((currentEvent.value.website) = $event)),
                              name: "website",
                              placeholder: "https://www.example.com...",
                              validation: "url"
                            }, null, 8, ["modelValue"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormKit, {
                    type: "step",
                    name: "stepTwo",
                    label: "Fiche entreprise"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_FormKit, {
                          type: "datetime-local",
                          modelValue: currentEvent.value.dateDebut,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((currentEvent.value.dateDebut) = $event)),
                          name: "dateDebut",
                          label: "Date de début",
                          help: "Quand commence l'événement",
                          validation: "required|date_after",
                          "validation-visibility": "live"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "datetime-local",
                          modelValue: currentEvent.value.dateFin,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((currentEvent.value.dateFin) = $event)),
                          name: "dateFin",
                          label: "Date de Fin",
                          help: "Quand ce termine l'événement",
                          validation: "required|date_after",
                          "validation-visibility": "live"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "number",
                          label: "Nombres de places",
                          modelValue: currentEvent.value.nombreDePlaces,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentEvent.value.nombreDePlaces) = $event)),
                          name: "nombreDePlaces",
                          step: "1"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormKit, {
                    type: "step",
                    name: "stepThree",
                    label: "Présentation de l'événement"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(_component_FormKit, {
                          name: "images",
                          type: "file",
                          label: "Images de l'événement",
                          help: "Nous vous conseillons d'en mettre 1 minimum",
                          multiple: "true",
                          accept: "image/*"
                        }),
                        _createVNode(_component_FormKit, {
                          name: "description",
                          modelValue: currentEvent.value.description,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((currentEvent.value.description) = $event)),
                          maxlength: "80",
                          type: "textarea",
                          label: "Présentation courte de l'événement",
                          rows: "10"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_FormKit, {
                    type: "step",
                    name: "stepFour",
                    label: "Emplacement"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(_component_FormKit, {
                            name: "adresse",
                            "floating-label": true,
                            label: "Adresse de l'événement"
                          }),
                          _createVNode(_component_FormKit, {
                            name: "codePostale",
                            "floating-label": true,
                            label: "Code postale"
                          }),
                          _createVNode(_component_FormKit, {
                            name: "ville",
                            "floating-label": true,
                            label: "Ville"
                          }),
                          _createVNode(_component_FormKit, {
                            type: "button",
                            onClick: checkAdress
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" mettre à jour l'adresse ")
                            ]),
                            _: 1
                          })
                        ]),
                        (is_map_active.value)
                          ? (_openBlock(), _createBlock(_unref(LMap), {
                              key: 0,
                              ref: "map",
                              zoom: 11,
                              center: [currentEvent.value.location.coordinates[1], currentEvent.value.location.coordinates[0]]
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(LTileLayer), {
                                  url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
                                  "layer-type": "base",
                                  name: "OpenStreetMap"
                                }),
                                _createVNode(_unref(LMarker), {
                                  "lat-lng": [contact.value.lat, contact.value.long]
                                }, null, 8, ["lat-lng"])
                              ]),
                              _: 1
                            }, 8, ["center"]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", {
        class: "card",
        onClick: activeForm
      }, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(PlusCircleOutlineIcon)
        ]),
        _hoisted_17
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(events.value, (event, indexEvent) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "card",
          onClick: ($event: any) => (newEvent(event)),
          key: indexEvent
        }, [
          _createElementVNode("div", {
            class: "rk_closeEvent card_close",
            onClick: _withModifiers(($event: any) => (deleteEvent(event, indexEvent)), ["stop"])
          }, null, 8, _hoisted_19),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("img", {
              src: urlServer.value + event.images[0],
              alt: event.nomEvent
            }, null, 8, _hoisted_21)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", null, _toDisplayString(event.nomEvent), 1)
          ])
        ], 8, _hoisted_18))
      }), 128))
    ])
  ]))
}
}

})